{
    "required": "This field is required.",
    "email": "Enter a valid email address.",
    "min_length": "Must be at least {{count}} characters.",
    "max_length": "Must be no more than {{count}} characters.",
    "phone_om": "Enter a valid Omani number, for example +968 9123 4567.",
    "civil_id": "A civil ID is 8 digits.",
    "passwords_match": "The passwords do not match.",
    "invalid_colour": "Enter a hex colour such as #0B2A4A.",
    "file_too_large": "This file is larger than the {{max}} limit.",
    "file_type": "This file type is not accepted."
}
